import { render, staticRenderFns } from "./downloadCustom.vue?vue&type=template&id=74ff8ec0&scoped=true&"
import script from "./downloadCustom.vue?vue&type=script&lang=js&"
export * from "./downloadCustom.vue?vue&type=script&lang=js&"
import style0 from "./downloadCustom.vue?vue&type=style&index=0&id=74ff8ec0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74ff8ec0",
  null
  
)

component.options.__file = "downloadCustom.vue"
export default component.exports